import type { ModalTokens } from './types';

export const modal: ModalTokens = {
  radii: {
    default: 'big',
  },
};
